import styled from 'styled-components';

import { MessageDateSeparator } from '@web/conversations/Message/MessageDateSeparator/MessageDateSeparator';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.bodyBg}80;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 20px 20px 20px 16px;
  transition: box-shadow 0.2s ease-in-out;
  margin-bottom: 10px;
  margin-top: 10px;

  &:hover {
    cursor: pointer;
    box-shadow: 0 5px 10px ${({ theme }) => theme.colors.boxShadowDarker};
  }
`;

export const SearchItemHeader = styled.header`
  align-items: center;
  display: flex;
  gap: 5px;
  height: 32px;
  margin-bottom: 8px;
`;

export const SearchItemDateSeparator = styled(MessageDateSeparator)`
  margin-bottom: 20px;
`;
